import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useEditor from './useEditor';
import useDesign from 'packages/pages/design/hooks/useDesign';
import { currentEditorType } from 'packages/store/creativeEditor/creativeEditor.selectors';

export default function useMultiPageValidation() {
    const editorType = useSelector(currentEditorType);
    const designContext = useDesign();
    const editorContext = useEditor();
    const { validationManager } = editorType === 'create' ? designContext : editorContext;
    const [isValid, setValid] = useState(() => validationManager?.isValid() ?? false);
    const [globalPropertiesValidations, setGlobalPropertiesValidations] = useState(
        () => validationManager?.getAllGlobalPropertiesValidationStates() ?? [],
    );

    useEffect(() => {
        if (!validationManager) {
            return;
        }

        setValid(validationManager.isValid());

        const validationChangeListener = () => {
            setValid(validationManager.isValid());
        };

        return validationManager.onValidationChange(validationChangeListener);
    }, [validationManager]);

    useEffect(() => {
        if (!validationManager) {
            return;
        }

        setGlobalPropertiesValidations(validationManager.getAllGlobalPropertiesValidationStates());

        const validationGlobalsChangeListener = () => {
            setGlobalPropertiesValidations(validationManager.getAllGlobalPropertiesValidationStates());
        };

        return validationManager.onGlobalPropertiesValidationChange(validationGlobalsChangeListener);
    }, [validationManager]);

    return { isValid, globalPropertiesValidations };
}
